import { useSelector } from "react-redux";

import { selectCountriesFilterValue } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

export const useCurrentOpportunityListCountry = (): number => {
    const countriesFromFilter = useSelector(selectCountriesFilterValue);

    return countriesFromFilter?.[0] ?? WORLDWIDE_COUNTRY_ID;
};
